"use strict";
import { Map } from "immutable";
export default {
  create() {
    return Map({
      __type__: "ClearCache"
    });
  },
  isClearCache(object) {
    return Map.isMap(object) && object.get("__type__") === "ClearCache";
  }
};
